function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../../../framework/publisher2/tools/AbstractPublisherTool';
import { MyLocationComponent } from './MyLocationComponent';
import { MyLocationToolHandler } from './MyLocationHandler';
var MyLocationTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function MyLocationTool() {
    var _this;
    _classCallCheck(this, MyLocationTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MyLocationTool, [].concat(args));
    _this.index = 100;
    _this.group = 'tools';
    _this.handler = new MyLocationToolHandler(_this);
    return _this;
  }
  _inherits(MyLocationTool, _AbstractPublisherToo);
  return _createClass(MyLocationTool, [{
    key: "init",
    value: function init(data) {
      var _this$state;
      _superPropGet(MyLocationTool, "init", this, 3)([data]);
      var config = ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.pluginConfig) || {};
      this.handler.init(config);
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return {
        component: MyLocationComponent,
        handler: this.handler
      };
    }

    /**
    * Get tool object.
    * @method getTool
    *
    * @returns {Object} tool description
    */
  }, {
    key: "getTool",
    value: function getTool() {
      var _this$state2;
      return {
        id: 'Oskari.mapframework.bundle.mapmodule.plugin.MyLocationPlugin',
        title: Oskari.getMsg('MapModule', 'publisherTools.MyLocationPlugin.toolLabel'),
        config: ((_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.pluginConfig) || {}
      };
    }
  }, {
    key: "getValues",
    value: function getValues() {
      if (!this.isEnabled()) {
        return null;
      }
      var pluginConfig = this.getPlugin().getConfig() || {};
      // update extras
      var state = this.handler.getState();
      for (var key in state) {
        if (state.hasOwnProperty(key)) {
          pluginConfig[key] = state[key];
        }
      }
      return {
        configuration: {
          mapfull: {
            conf: {
              plugins: [{
                id: this.getTool().id,
                config: pluginConfig
              }]
            }
          }
        }
      };
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.MyLocationTool', MyLocationTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});
export { MyLocationTool };